<template>
  <v-app id="inspire"  class="c-bg-gray">
    <v-main>
      <v-container class="fill-height" fluid >
        <v-col cols="12" class="col-md-10 offset-md-1 col-sm-12 tw-mt-5 md:tw-mt-0">
          <v-row
          align="center"
          justify="center"
        >
          <v-col id="reset-password" cols="12" sm="8" md="5">
            <v-card class="elevation-3 pb-5">
              <div class="tw-w-full tw-flex tw-justify-center">
                <img src="/logo.svg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo">
              </div>
              <v-card-text class="tw-px-4 md:tw-px-10">
                <div class="tw-w-full tw-text-center tw-mt-6">
                  <h2 class="c-blue-text title tw-mb-5">Reset Password</h2>
                </div>
                <v-form v-model="isValid">
                  <v-text-field
                    id="otp"
                    label="OTP"
                    type="number"
                    v-model="form.otp"
                    :rules="[required('OTP')]"
                  >
                    <v-icon slot="prepend" color="primary">mdi-security</v-icon>
                  </v-text-field>

                  <v-text-field
                    id="password"
                    label="New password"
                    :type="passwordField"
                    v-model="form.password"
                    :rules="[required('Password'), minLength('password', 8), lowerCaseFormat(), upperCaseFormat(), digitFormat(), specialCharFormat()]"
                  >
                    <v-icon slot="prepend" color="primary">mdi-lock</v-icon>
                    <v-icon slot="append" color="primary" class="tw-cursor-pointer" @click="passwordField = passwordField === 'password' ? 'text' : 'password'">{{ passwordField === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  </v-text-field>

                  <v-text-field
                    id="confirm-new-password"
                    label="Confirm new password"
                    :type="passwordConfirmField"
                    v-model="form.confirmPassword"
                    :rules="[required('Confirm Password'), confirmPassword('Confirm Password', form.password)]"
                  >
                    <v-icon slot="prepend" color="primary">mdi-lock</v-icon>
                    <v-icon slot="append" color="primary" class="tw-cursor-pointer" @click="passwordConfirmField = passwordConfirmField === 'password' ? 'text' : 'password'">{{ passwordConfirmField === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="col-sm-6 offset-sm-3">
                <v-btn block large
                       id="submit"
                       color="secondary"
                       class="my-3 "
                       @click="onUpdatePassword"
                       :disabled="!isValid"
                       :loading="loading">
                  Reset Password
                </v-btn>
              </v-card-actions>
              <v-card-actions class="tw-w-full tw-flex justify-center">
                <a id="otp-resend" class="tw-font-bold" href="#" @click.prevent="resendOtp">{{ resend }}</a>
              </v-card-actions>
              <v-card-actions class="tw-w-full tw-flex justify-center tw-pb-10">
                <span class="c-gray-text body-2" >Already Have an account ? <router-link class="tw-font-bold" :to="{ name: 'SignIn' }">LOGIN</router-link> </span>
              </v-card-actions>
            </v-card>
          </v-col>
          <div class="tw-w-full tw-grid tw-grid-cols-2 tw-absolute tw-left-0 tw-bottom-0">
            <div class="c-bg-blue tw-py-1"></div>
            <div class="c-bg-red tw-py-1"></div>
          </div>
        </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

import validations from '@/utils/validations';
import { mapGetters } from 'vuex';
import helpers from '@/utils/helpers';
import { FB_RESET_PASS_COMPLETE } from '@/utils/const';
import secureValidation from '@/utils/secureValidation';

export default {
  metaInfo: {
    title: 'Reset Password',
  },
  props: {
    source: String,
  },
  data() {
    return {
      form: {
        confirmPassword: '',
        password: '',
        otp: '',
      },
      username: '',
      ...validations,
      loading: false,
      isValid: false,
      resend: 'Resend OTP',
      passwordField: '',
      passwordConfirmField: '',
    };
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus']),
  },
  mounted() {
    const param = this.$route.query.user;
    if (!param || !secureValidation.validateEmail(param)) {
      this.$toast.error('Invalid address, please request for code', 'Error');
      this.$router.push({ name: 'ForgotPassword' });
    }
    this.username = param;
    this.$store.dispatch('auth/clearAuthenticationStatus');
  },
  methods: {
    async onUpdatePassword() {
      await this.$store.dispatch('auth/confirmPasswordReset', {
        username: this.username,
        code: this.form.otp,
        password: this.form.password,
      }).then(() => {
        this.loading = false;
        this.$analytics.logEvent(FB_RESET_PASS_COMPLETE);
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
          } else {
            this.$toast.success(this.authenticationStatus.message, 'Success');
            helpers.clearForm(this.form);
            this.$router.push({ name: 'SignIn' });
          }
        }
      });
    },
    async resendOtp() {
      this.resend = 'Resending OTP...';
      await this.$store.dispatch('auth/passwordReset', {
        username: this.username,
      }).then(() => {
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
          } else {
            this.$toast.success(this.authenticationStatus.message, 'Success');
          }
        }
        this.resend = 'Resend OTP';
      });
    },
  },
};
</script>
